module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "parallax"
  }), _vm._v(" "), _c('div', {
    staticClass: "container",
    attrs: {
      "id": "servicesRDV"
    }
  }, [_c('h2', [_vm._v(" Serveis amb cita ")]), _vm._v(" "), _c('div', {
    staticClass: "services"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('h3', [_vm._v(" Cirurgia ")]), _vm._v(" "), _c('p', [_vm._v(" Cirurgia de teixits tous ")]), _vm._v(" "), _c('P', [_vm._v(" Ovariectomia ")]), _vm._v(" "), _c('P', [_vm._v(" Castració ")]), _vm._v(" "), _c('p', [_vm._v(" Odontologia ")])], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block"
  }, [_c('h3', [_vm._v("Consulta")]), _vm._v(" "), _c('p', [_vm._v("Enfocament global basat en la nutrició i el comportament per\n           aconseguir junts el benestar del teu company.")]), _vm._v(" "), _c('p', [_vm._v("Consultes homeopàtiques")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block"
  }, [_c('h3', [_vm._v("Plataforma tècnica")]), _vm._v(" "), _c('p', [_vm._v("Echografia")]), _vm._v(" "), _c('p', [_vm._v("Radiografia")]), _vm._v(" "), _c('p', [_vm._v("Hematologia")]), _vm._v(" "), _c('p', [_vm._v("Bioquímica")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7feace64"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Cat/ServicesRDV.vue
// module id = 148
// module chunks = 0